var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerishable1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 0C9.33333 0 0 9.33333 0 20.8333C0 32.3333 9.33333 41.6667 20.8333 41.6667C32.3333 41.6667 41.6667 32.3333 41.6667 20.8333C41.6667 9.33333 32.3333 0 20.8333 0ZM4.16667 20.8333C4.16667 11.625 11.625 4.16667 20.8333 4.16667C24.6875 4.16667 28.2292 5.47917 31.0417 7.6875L7.6875 31.0417C5.47917 28.2292 4.16667 24.6875 4.16667 20.8333ZM20.8333 37.5C16.9792 37.5 13.4375 36.1875 10.625 33.9792L33.9792 10.625C36.1875 13.4375 37.5 16.9792 37.5 20.8333C37.5 30.0417 30.0417 37.5 20.8333 37.5Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerishable1);
export default __webpack_public_path__ + "static/media/perishable1.bc2910419856a46752937687fdda296e.svg";
export { ForwardRef as ReactComponent };